import { PersonStore } from "../../store/modules/person";
import { DiTokens } from "../../services/diTokens";
import IAlertService from "../../services/alert/IAlertService";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import { container } from "@/inversify.config";
import i18n from "@/i18n";

export class AliasEditModalVue extends Vue {
  /** Стор профиля */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  aliasValue: string = this.personStore.personInfo.Data.Alias;

  valid: boolean = true;

  personAliasRules: Array<Function> = [
    (a: string) => !!a || i18n.t("main.settings.errors.personAliasEmpty"),
    (a: string) =>
      (a && new RegExp("^[a-zA-Z0-9_-]{3,20}$").test(a)) ||
      i18n.t("main.settings.errors.personAliasMaxLength")
  ];

  get aliasLoading(): boolean {
    return this.personStore.loading;
  }

  async setPersonAlias() {
    (this.$refs.aliasForm as any).validate();
    if (!this.valid) return;

    if (this.aliasValue === this.personStore.personInfo.Data.Alias) {
      this.alertService.warning(
        i18n.t("main.settings.errors.noChanges").toString()
      );
      return;
    }

    await this.personStore.setPersonAlias(this.aliasValue);
    if (this.aliasValue === this.personStore.personInfo.Data.Alias)
      this.destroyOperation();
  }

  destroyOperation() {
    this.$emit("hideSelf");
  }
}
